var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCaretLeftRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B82B27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1272 3773L1284.5 3760 1297 3773",
    transform: "translate(-1276 -3753) rotate(-90 1284.5 3766.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaretLeftRed);
export default __webpack_public_path__ + "static/media/ic-caret-left-red.8a3f6adfb1e33a2914ae04dac588d10c.svg";
export { ForwardRef as ReactComponent };